module.exports = __webpack_public_path__ + "img/picture_17.23a3e593.png";